import './assets/styles/main.scss';
import '@fortawesome/fontawesome-free/css/all.min.css';

import {createRoot} from 'react-dom/client';
import AppLoader from './AppLoader';
import reportWebVitals from './reportWebVitals';

import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <QueryClientProvider client={queryClient}>
      <AppLoader />
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
